<template>

  <section class="container" id="editcontact">
    
  <div class="backbutton">
    <div class="columns flex alignMiddle">
      <div class="column grow">
          <a href="#!" class="button" v-on:click="goBack">Zurück</a>
      </div>
    </div>
  </div>
    
    
    <div class="columns">
      <div class="column">
        <h1>{{firstname}} {{lastname}}</h1>
      </div>
    </div>
    
    <div role="form" id="addcompanybox" autocomplete="off">
    
    <div class="columns flex aligncenter">
      <div class="column half ">
    
          <div class="field">
            <div class="control control-100 with-icon">
              <input class="input" type="text" placeholder="Firma" v-model="companytemp" id="companytemp" @input="onChange" autocomplete="off"
                @keydown.down="onArrowDown"
                @keydown.up="onArrowUp"
                @keydown.enter="onEnter"
                @blur="onBlur"
                :class=" (companyid ? 'matched' : '') " 
              >
              <label class="input-icon icon-company" for="companytemp">Firma</label>   
              <div class="iconafter" v-on:click="newcompany" id="newcompany">hinzufügen</div>       

            <div class="autoc" v-if="(isOpen && results.length > 0)">
                <ul class="autoc_results">
                  <li v-for="(result, i) in results" :key="i" class="autoc_result" @click="setResult(result)" :class="{ 'is-active': i === arrowCounter }">
                    {{ result.company }} {{ result.companycity }}
                  </li>
                </ul>              
            </div>


            </div>            


          </div>
          <div><p><small>Firma suchen und übernehmen oder auf + klicken und neue Firma anlegen</small></p></div>

          <div id="addcompany">
           <div id="addcompanyclose" v-on:click="addcompanyClose"></div>             
          <div id="addcompany_box">    
            
            <div class="field">
              <div class="control control-100">
                <input class="input" type="text" placeholder="Firma" v-model="company"   autocomplete="nope">
                <label class="input-icon icon-company" for="company">Firma</label>                    
              </div>
            </div>          
            
    
            <div class="field">
              <div class="control control-100">
                <input class="input" type="text" placeholder="Straße und Nr." v-model="companyaddress"   autocomplete="nope">
                <label class="input-icon icon-address" for="companyaddress">Anschrift</label>                    
              </div>
            </div>
      
      
            <div class="field">
              <div class="control control-50">
                <input class="input" type="text" placeholder="Postleitzahl" v-model="companyzipcode"   autocomplete="nope">
                <label class="input-icon icon-address" for="companyzipcode">PLZ</label>                    
              </div>
              <div class="control control-50">
                <input class="input" type="text" placeholder="Stadt" v-model="companycity"   autocomplete="nope">
              </div>
            </div>
      
            <div class="field">
              <div class="control control-100 with-icon">
                <input class="input" type="email" placeholder="E-Mail Adresse" v-model="companyemailaddress" id="companyemailaddress"   autocomplete="nope">
                <label class="input-icon icon-send" for="companyemailaddress">E-Mail</label>          
              </div>
            </div>
      
            <div class="field">
              <div class="control control-50 with-icon">
                <input class="input" type="text" placeholder="Telefon" v-model="companyphonenumber" id="companyphonenumber"   autocomplete="nope">
                <label class="input-icon icon-phone" for="companyphonenumber">Telefon</label>          
              </div>
              <div class="control control-50 with-icon">
                <input class="input" type="text" placeholder="Fax" v-model="companyfaxnumber" id="companyfaxnumber"   autocomplete="nope">
                <label class="input-icon icon-fax" for="companyfaxnumber">Fax</label>          
              </div>
            </div>
      
            <div class="field">
              <div class="control control-100">
                <input class="input" type="text" placeholder="Website" id="companywebsite" v-model="companywebsite"   autocomplete="nope">
                <label class="input-icon icon-website" for="companywebsite">Website</label>                    
              </div>
            </div>          

      
            <div class="field">
              <div class="control control-100">
                <input class="input" type="text" placeholder="Land" v-model="companycountry"   autocomplete="nope">
                <label class="input-icon icon-flag" for="companycountry">Land</label>                    
              </div>
            </div>          

            <div class="field">
              <div class="control">
                <button type="submit" class="button is-link" v-on:click="saveCompany">Firma anlegen</button>
              </div>
            </div>

        </div>
      </div>
            
            
            
            
          </div>
          </div>
    
      </div>
    </div>    



    <div class="columns flex alignTop">
       <div class="column">
            <div class="field ">
              <div class="control control-100">
                <input id="typ_intern" name="typ" type="radio" v-model="typ" value="i" v-bind:checked="typ == 'i'"><label for="typ_intern">Interner Mitarbeiter</label>
                <input id="typ_extern" name="typ" type="radio" v-model="typ" value="e" v-bind:checked="typ == 'e'"><label for="typ_extern">Externer Mitarbeiter</label>
<!--                 <input id="typ_kunde" name="typ"  type="radio" v-model="typ" value="k" v-bind:checked="typ == k"><label for="typ_kunde">Kunde</label> -->
              </div>
              
            </div>
       </div>
    </div>

    
    <div class="columns flex alignTop">
       <div class="column half">


    
            <div class="field">
              <div class="control control-50">
                <input class="input" type="text" placeholder="Vorname" v-model="firstname"   autocomplete="nope"> 
              </div>
              <div class="control control-50">
                <input class="input" type="text" placeholder="Nachname" v-model="lastname"   autocomplete="nope">
              </div>
            </div>
      
            <div class="field">
              <div class="control control-50">
                <input class="input" type="text" placeholder="Ausbildung" v-model="education"   autocomplete="nope"> 
              </div>
              <div class="control control-50">
                <input class="input" type="text" placeholder="Position" v-model="position"   autocomplete="nope"> 
              </div>
            </div>
            <div class="field">
              <div class="control control-100">
                <input class="input" type="text" placeholder="Abteilung" v-model="department"   autocomplete="nope">
              </div>
            </div>
      
      
            <div class="field">
              <div class="control control-100">
                <input class="input" type="email" placeholder="E-Mail Adresse" v-model="emailaddress" id="emailaddress"   autocomplete="nope">
                <label class="input-icon icon-send" for="emailaddress">E-Mail</label>          
              </div>
            </div>
      
            <div class="field">
              <div class="control control-100">
                <input class="input" type="text" placeholder="Telefon" v-model="phonenumber" id="phonenumber"   autocomplete="nope">
                <label class="input-icon icon-phone" for="phonenumber">Telefon</label>          
              </div>
            </div>
            
            <div class="field">
              <div class="control control-100">
                <input class="input" type="text" placeholder="Mobil" v-model="mobile" id="mobile"   autocomplete="nope">
                <label class="input-icon icon-mobile" for="mobile">Mobil</label>          
              </div>
            </div>
      
           <div class="field">
              <div class="control control-100">
                <input class="input" type="text" placeholder="Straße Haus-Nr." v-model="address" id="address"   autocomplete="nope">
                <label class="input-icon icon-address" for="address">Straße Haus-Nr.</label>          
              </div>
            </div>

           <div class="field">
              <div class="control control-100">
                <input class="input" type="text" placeholder="Adress-Zusatz" v-model="address2" id="address2"   autocomplete="nope">
                <label class="input-icon icon-address" for="address2">Adress-Zusatz</label>          
              </div>
            </div>
      
      
            <div class="field">
              <div class="control control-50">
                <input class="input" type="text" placeholder="Postleitzahl" v-model="zipcode"   autocomplete="nope">
              </div>
              <div class="control control-50">
                <input class="input" type="text" placeholder="Stadt" v-model="city"   autocomplete="nope">
              </div>
            </div>
      
            <div class="field">
              <div class="control control-100">
                <input class="input" type="email" placeholder="Land" v-model="country" id="country"   autocomplete="nope">
                <label class="input-icon icon-flag" for="country">Land</label>                    
              </div>
            </div>

                   
      </div>            
      <div class="column half">
        
            <div class="field">
              <div class="control control-50">
                <input class="input" type="text" placeholder="Geburtstag" v-model="birthday"   autocomplete="nope"> 
              </div>
              <div class="control control-50">
                <input class="input" type="text" placeholder="PA-Nr." v-model="panr"   autocomplete="nope">
              </div>
            </div>

            <div class="field">
              <div class="control control-50">
                <input class="input" type="text" placeholder="KK" v-model="kk"   autocomplete="nope"> 
              </div>
              <div class="control control-50">
                <input class="input" type="text" placeholder="Vers.-Nr." v-model="versnr"   autocomplete="nope">
              </div>
            </div>


            <div class="field">
              <div class="control control-50">
                <input class="input inline" type="checkbox" v-model="eh" id="eh"  autocomplete="nope"><label for="eh">EH</label>
              </div>
              <div class="control control-50">
                <input class="input inline" type="checkbox" id="sibe" v-model="sibe"   autocomplete="nope"><label for="sibe">SIBE</label>
              </div>
            </div>

            <div class="field">
              <div class="control control-50">
                <input class="input inline" type="checkbox" id="stapler" v-model="stapler"   autocomplete="nope"><label for="stapler">Stapler</label>
              </div>
              <div class="control control-50">
                <input class="input inline" type="checkbox" id="kran" v-model="kran"   autocomplete="nope"><label for="kran">Kran</label>
              </div>
            </div>

            <div class="field">
              <div class="control control-50">
                <input class="input inline" type="checkbox" id="sivv" v-model="sivv"   autocomplete="nope"><label for="sivv">SIVV</label>
              </div>
              <div class="control control-50">
                <input class="input inline" type="checkbox" id="winde" v-model="winde"   autocomplete="nope"><label for="winde">Winde</label>
              </div>
            </div>
            
            <div class="field">
              <div class="control control-50">
                <input class="input inline" type="checkbox" id="dat" v-model="dat"   autocomplete="nope"><label for="dat">DAT</label>
              </div>
              <div class="control control-50">
                <input class="input inline" type="checkbox" id="hoehent" v-model="hoehent"   autocomplete="nope"><label for="hoehent">Höhent.</label>
              </div>
            </div>

            <div class="field">
              <div class="control control-50">
                <input class="input" type="text" placeholder="Spritzen" v-model="spritzen"   autocomplete="nope"> 
              </div>
              <div class="control control-50">
                <input class="input" type="text" placeholder="Mauern" v-model="mauern"   autocomplete="nope">
              </div>
            </div>

            <div class="field">
              <div class="control control-50">
                <input class="input" type="text" placeholder="Faser" v-model="faser"   autocomplete="nope"> 
              </div>
              <div class="control control-50">
                <input class="input inline" type="checkbox" v-model="engl" id="engl"  autocomplete="nope"><label for="engl">Englisch</label>
              </div>
            </div>
            
        
      </div>
    </div>
    
    <div class="columns small-flex spacebetween">
       <div class="column">
            <div class="field">
              <div class="control">
                <button type="submit" class="button is-link" v-on:click="saveContact">Speichern</button>
              </div>
            </div>
        </div>
       <div class="column">
            <div class="field">
              <div class="control">
                <button type="submit" class="button is-link delete" v-on:click="delContact">Löschen</button>
              </div>
            </div>
        </div>

      </div>

    </div><!-- /#form -->
  </section>
  
</template>
<script>
import firebase from 'firebase'
  
export default {
  name: 'EditContact',
  data: function(){ 
    return {
          companies: [],          
          results: [],
          isOpen: false,
          loading: false,
          arrowCounter: -1,
          
          companytemp: '',
          
          company: '',
          

          companyaddress: null,
          companyzipcode: null,
          companycity: null,
          companyemailaddress: null,
          companyphonenumber: null,
          companyfaxnumber: null,
          companywebsite: null,
          companycountry: null,

          
          companyid: null,
      
          firstname: null,
          lastname: null,
          education: null,
          position: null,
          department: null,
          emailaddress: null,
          phonenumber: null,
          mobile: null,
          zipcode: null,
          city: null,
          address: null,
          address2: null,
          country: null,
          
          birthday: null,
          panr: null,
          kk: null,
          versnr: null,
          eh: false,
          sibe: false,
          stapler: false,
          kran: false,
          sivv: false,
          winde: false,
          dat: false,
          hoehent: false,
          spritzen: null,
          mauern: null,
          faser: null,
          engl: false,
          
          typ: ''
    }
  },
  methods: {
    
    goBack: function(e){
      e.preventDefault();
      this.$router.go(-1)
    },
    
      handleESC(e){
        if (e.which == 27) {
          this.isOpen = false;
          document.getElementById("addcompanybox").classList.remove('visible')                        
          }
      },
      
      handleClickOutside(evt) {
      if (this.$el.contains(evt.target)) {
        this.isOpen = false;
        this.arrowCounter = -1;
        }
      },
              
      onArrowDown() {
        if (this.arrowCounter < this.results.length -1) {
          this.arrowCounter = this.arrowCounter + 1;
        }
        console.log('onArrowDown ' + this.arrowCounter + " " + this.results.length);
      },
      onArrowUp() {
        if (this.arrowCounter > 0) {
          this.arrowCounter = this.arrowCounter - 1;
        }
      },
      onEnter() {
        this.search = this.results[this.arrowCounter];
        this.isOpen = false;
        this.arrowCounter = -1;
      },
      onEsc(){
        console.log('esc');
        this.isOpen = false;  
        this.results = []     
        this.arrowCounter = -1;         
      },
    
        onChange() {
          this.companyid = null          
          this.isOpen = true;
          this.loading = true;
          this.filterResults();
        },
        onBlur(){
/*
        this.isOpen = false;          
        this.arrowCounter = -1;         
        if( this.results.length < 1 || this.companytemp)
            this.companyid = null

            console.log(this.companyid);
*/
        },
        

      filterResults() {
        // first uncapitalize all the things
        this.results = this.companies.filter((item) => {
          var r = (
            
            (item.company && item.company.toLowerCase().indexOf(this.companytemp.toLowerCase()) > -1)
            ||
            (item.companyaddress && item.companyaddress.toLowerCase().indexOf(this.companytemp.toLowerCase()) > -1)
            ||
            (item.companycity && item.companycity.toLowerCase().indexOf(this.companytemp.toLowerCase()) > -1)
                        
            
            )
            console.log(r)
            return r; 
        })
      },
      setResult(result) {
        this.companyid = result.slug;
        this.companytemp = result.company + ", " + result.companycity
        this.isOpen = false;
        this.results = [];
      },        

      addcompanyClose(){
          document.getElementById("addcompanybox").classList.remove('visible')        
      },
      newcompany (){
          document.getElementById("addcompanybox").classList.toggle('visible')
          return
      },
      saveCompany(){
              var newCompanySlug =  this.generateUUID() 
              
              firebase.firestore().collection('contacts').add({
                company: this.company,
                companyemailaddress: this.companyemailaddress,
                companyphonenumber: this.companyphonenumber,
                companyfaxnumber: this.companyfaxnumber,
                companywebsite: this.companywebsite,
                companyzipcode: this.companyzipcode,
                companycity: this.companycity,
                companyaddress: this.companyaddress,
                companycountry: this.companycountry,
                slug: newCompanySlug
              })
              .then( (docRef) => {         
                  this.$swal('Die Firma wurde angelegt!');
                  document.getElementById("addcompanybox").classList.remove('visible')    
                  this.companyid = newCompanySlug;
                  this.companytemp = this.company + ", " + this.companycity
                  this.isOpen = false;
                  this.results = [];
                      
                  this.companies.push({
                  company: this.company,
                  companyemailaddress: this.companyemailaddress,
                  companyphonenumber: this.companyphonenumber,
                  companyfaxnumber: this.companyfaxnumber,
                  companywebsite: this.companywebsite,
                  companyzipcode: this.companyzipcode,
                  companycity: this.companycity,
                  companyaddress: this.companyaddress,
                  companycountry: this.companycountry,
                  slug: newCompanySlug  
                  }) 
                      
                  //Object.assign(this.$data, this.$options.data());
                  //console.log('Document written with ID: ', docRef.id)
               })
               .catch(function (error) {
                  this.$swal('Das Speichern ist fehlgeschlagen');                   
                  //console.error('Error adding document: ', error)
               })
              

      },
      saveContact () {
          
          self = this;
          
              var updates = {
                companyid: this.companyid,
                firstname: this.firstname,
                lastname: this.lastname,
                emailaddress: this.emailaddress,
                phonenumber: this.phonenumber,
                mobile: this.mobile,
                education: this.education,
                position: this.position,
                department: this.department,
                zipcode: this.zipcode,
                city: this.city,
                address: this.address,
                address2: this.address2,
                country: this.country,

                birthday: this.birthday,
                panr: this.panr,
                kk: this.kk,
                versnr: this.versnr,
                eh: this.eh,
                sibe: this.sibe,
                stapler: this.stapler,
                kran: this.kran,
                sivv: this.sivv,
                winde: this.winde,
                dat: this.dat,
                hoehent: this.hoehent,
                spritzen: this.spritzen,
                mauern: this.mauern,
                faser: this.faser,
                engl: this.engl,
                
                typ: this.typ
                

                }
                console.log(updates);
                this.ref.update(updates)
                    .then( (docRef) => {       
                        this.$swal({
                          title: 'Kontakt aktualisiert',
                          type: 'success',
                          showCancelButton: false,
                          confirmButtonText: 'OK und zurück'
                        }).then((result) => {
                          if (result.value) {
                            this.$router.push('/view-contact/' + this.slug )
                          }
                        })                        
                      })
                      .catch(function (error) {
                        this.$swal('Das Aktualisieren ist fehlgeschlagen');                   
                      })
        },
        delContact () {
          
            var self = this;
          
                        this.$swal({
                          title: 'Kontakt wirklich löschen?',
                          type: 'warning',
                          showCancelButton: true,
                          cancelButtonText: 'abbrechen',
                          confirmButtonText: 'Ja, löschen'
                        }).then((result) => {
                          if (result.value) {

                              this.ref.delete().then( () => {

                                  this.$swal({
                                    title: 'Kontakt gelöscht',
                                    type: 'success',
                                    showCancelButton: false,
                                    confirmButtonText: 'OK, zurück zum Start'
                                  }).then((result) => {
                                        
                                        this.$router.push('/hello' )

                                  }).catch( (error) => {

                                  this.$swal({
                                    title: 'Kontakt nicht gelöscht',
                                    text: 'Fehler!',
                                    type: 'warning',
                                    showCancelButton: false,
                                    confirmButtonText: 'OK'
                                  })

                              });


                          })
                          }
                        })                        
          
          
        },
        generateUUID () {
          let d = new Date().getTime()
          let uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            let r = (d + Math.random() * 16) % 16 | 0
            d = Math.floor(d / 16)
            return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16)
          })
          return uuid
        }
  },
  destroyed() {
        document.removeEventListener('click', this.handleClickOutside);
        document.removeEventListener('keydown', this.handleESC);
  },
  mounted() {
  
        document.addEventListener('click', this.handleClickOutside);
        document.addEventListener('keydown', this.handleESC);
        
        firebase.firestore().collection('contacts').where('slug', '==', this.$route.params.contact).get().then((querySnapshot) => {

          this.loading = false
          querySnapshot.forEach((doc) => {
                
                this.ref = doc.ref,
                this.id = doc.data().id,
                this.companyid = doc.data().companyid,
                
                this.slug = doc.data().slug
                this.firstname = doc.data().firstname
                this.lastname = doc.data().lastname
                this.education = doc.data().education
                this.position = doc.data().position
                this.department = doc.data().department
                this.emailaddress = doc.data().emailaddress
                this.phonenumber = doc.data().phonenumber
                this.mobile = doc.data().mobile
                this.zipcode = doc.data().zipcode
                this.city = doc.data().city
                this.address = doc.data().address
                this.address2 = doc.data().address2
                this.country = doc.data().country
                
                this.birthday = doc.data().birthday
                
                this.panr = doc.data().panr
                this.kk = doc.data().kk
                this.versnr = doc.data().versnr
                this.eh = doc.data().eh == true ? true : false
                this.sibe = doc.data().sibe  == true ? true : false
                this.stapler = doc.data().stapler == true ? true : false
                this.kran = doc.data().kran == true ? true : false
                this.sivv = doc.data().sivv == true ? true : false
                this.winde = doc.data().winde == true ? true : false
                this.dat = doc.data().dat == true ? true : false
                this.hoehent = doc.data().hoehent == true ? true : false
                this.spritzen = doc.data().spritzen
                this.mauern = doc.data().mauern
                this.faser= doc.data().faser
                this.engl = doc.data().engl == true ? true : false
                                
                this.typ = doc.data().typ || 'n'
                                     

          })
        })
        
        
        firebase.firestore().collection('contacts').where('company','>','').orderBy('company','asc').get().then((querySnapshot) => {
          this.loading = false
          querySnapshot.forEach((doc) => {
            let data = {
              //'sortname' : doc.data().lastname ? doc.data().lastname : doc.data().company,
              'id': doc.id,
              'company': doc.data().company,
              'companycity':doc.data().companycity,
              'slug': doc.data().slug
            }
            
            if(this.companyid && this.companyid != "" && data.slug == this.companyid )
                 this.companytemp = doc.data().company + ", " + doc.data().companycity

            this.companies.push( data )
          })
        })        
        
        
      },

  
    
}  
</script>
<style>
  #editcontact { padding: 5rem 0 0 0; }
  #editcontact .field { display: flex; padding: 0; }
  #editcontact .control { padding: 0.43333333em; display: flex; }
  #editcontact .control-33 { flex: 1 1 33.3333%; width: 33.3333%; max-width: 33.33333%; }
  #editcontact .control-50 { flex: 1 1 50%; width: 50%; max-width: 50%; }
  #editcontact .control-100 { flex: 0 0 100%; width:100%; max-width: 100%; align-items: stretch; }
  #editcontact .control input[type=text] { width: 100%; min-width: 10%; margin: 0; }
  #editcontact .control input[type=email] { width: 100%;  min-width: 10%; margin: 0; }
  #editcontact .control input[type=checkbox] { width: auto;  min-width: 10%; margin: 0; }
  #editcontact .control input { border-radius: 0 3px 3px 0; }
  #editcontact .input-icon { display: inline-block; background: #fff; height: 45px; width: 48px; min-width: 48px; border-radius: 3px 0 0 3px; line-height: 45px; }
  #editcontact .control input { order: 2; }
  #editcontact .control input.inline { margin-top: 0.8333em; }
  #editcontact .control input.inline + label { order: 3; display: block; padding: 0.843333em; }

  #editcontact .control input-icon { order: 1; }
  #editcontact .control input:focus + .input-icon { border-color: #00aeff; }

  #editcontact .control input[type=radio] { display: inline; margin: 0; order: inherit;  }
  #editcontact .control input[type=radio] + label { display: inline-block !important; margin: 0 1.433333em 0 0.63333em;  order: inherit; }

  #editcontact .button.delete { border-color: #dc1200; }
  #editcontact .button.delete:focus,
  #editcontact .button.delete:hover { background: #dc1200; }

  #editcontact .icon-company { background: url(../assets/icons/disc.svg) center center no-repeat; background-size: 1.6333333em; border: 1px solid #d9d9d8; border-right: 0; text-indent: -9999px; }
  #editcontact .icon-phone { background: url(../assets/icons/phone.svg) center center no-repeat; background-size: 1.6333333em; border: 1px solid #d9d9d8; border-right: 0; text-indent: -9999px; }
  #editcontact .icon-fax { background: url(../assets/icons/print.svg) center center no-repeat; background-size: 1.6333333em; border: 1px solid #d9d9d8; border-right: 0; text-indent: -9999px; }
  #editcontact .icon-send { background: url(../assets/icons/envelope-alt.svg) center center no-repeat; background-size: 1.6333333em; border: 1px solid #d9d9d8; border-right: 0; text-indent: -9999px; }
  #editcontact .icon-flag { background: url(../assets/icons/flag.svg) center center no-repeat; background-size: 1.6333333em; border: 1px solid #d9d9d8; border-right: 0; text-indent: -9999px; }

  #editcontact .icon-mobile { background: url(../assets/icons/iphone.svg) center center no-repeat; background-size: 1.6333333em; border: 1px solid #d9d9d8; border-right: 0; text-indent: -9999px; }
  #editcontact .icon-flag { background: url(../assets/icons/flag.svg) center center no-repeat; background-size: 1.6333333em; border: 1px solid #d9d9d8; border-right: 0; text-indent: -9999px; }

  #editcontact .icon-address { background: url(../assets/icons/location.svg) center center no-repeat; background-size: 1.6333333em; border: 1px solid #d9d9d8; border-right: 0; text-indent: -9999px; }
  #editcontact .icon-website { background: url(../assets/icons/home-alt.svg) center center no-repeat; background-size: 1.6333333em; border: 1px solid #d9d9d8; border-right: 0; text-indent: -9999px; }

  #editcontact .control .iconafter#newcompany { display: inline-block; height: 48px; width: 48px; min-width: 48px; border: 0; line-height: 48px; order: 3; text-indent: -9999px; background: url(../assets/icons/add.svg) center center no-repeat; background-size: 1.6333333em; text-indent: -9999px; }

  #editcontact #addcompanybox .column { position: relative; }
  #editcontact #addcompany { height: auto; overflow: hidden; opacity: 0; width: 100%; max-height: 0; transition: max-height 0.3s ease-in-out, opacity 0.3s ease-in-out; cursor: pointer;
    position: fixed; top: 0; right: 0; bottom: 0; left: 0; background: rgb(255,255,255); z-index: 100;
  }
  .visible #addcompany { max-height: 1600px; opacity: 1; }
  .visible .control .iconafter#newcompany { background: url(../assets/icons/remove.svg) center center no-repeat; background-size: 1.6333333em; }
  #editcontact #addcompany_box { position: absolute; top: 0; right: 0; height: 100vh; left: 0; display: flex; flex-direction: column; justify-content: center; align-content: center; padding: 1.433333em; z-index: 101; }
  
  #editcontact #addcompanyclose { display: inline-block; height: 48px; width: 48px; min-width: 48px; border-radius: 24px; line-height: 48px; 
    position: absolute; top: 0.23333em; right: 0.933333em; background: #fff url(../assets/icons/close.svg) center center no-repeat; background-size: 2.76333333em; z-index: 102;
  }
  
  #editcontact .autoc {
    position: absolute; top: 5em; left: 0; background: #fff; z-index: 99;
    width: 100%; padding: 0 0.93333em;
  }

  #editcontact .autoc_results {
    padding: 0;
    margin: 0;
    border: 1px solid #d8d8d9;
    height: 10em;
    overflow: auto;
    width: 100% !important;
  }

  #editcontact .autoc_result {
    list-style: none;
    text-align: left;
    padding: 8px 10px;
    cursor: pointer;
  }
  #editcontact .autoc_result.is-active,
  #editcontact .autoc_result:hover {
    background-color: #d8d8d9;
/*     color: white; */
  }  
  #editcontact input#companytemp { height: 45px; }
  #editcontact input#companytemp { color: #dc1200; }
  #editcontact input#companytemp.matched { color: #6fb809}
  
  
</style>


// WEBPACK FOOTER //
// src/components/EditContact.vue